import { render, staticRenderFns } from "./UploadCreative.vue?vue&type=template&id=c01a607e&scoped=true"
import script from "./UploadCreative.vue?vue&type=script&lang=js"
export * from "./UploadCreative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01a607e",
  null
  
)

export default component.exports